import { GradeDto } from '../grades/grade';
import { MixtureDto, MixtureProductDto } from '../mixtures/mixture';
import { PackagingDto } from '../packagings/packaging';
import { PalletDto } from '../pallets/pallet';
import { ProductTypeDto } from '../producttypes/producttype';
import { RunSystemDto } from '../runsystems/runsystem';
import { SegmentDto } from '../segments/segment';
import {
  SpecificationDto,
  SpecificationParameterDto
} from '../specifications/specification';
import { UserDto } from '../users/user';
import {
  ProductParameterDetailDto,
  ProductParameterDto
} from './productParameter';
import { ProductProductDto } from './productProduct';

export interface ProductBaseDto {
  runNo: number;
  lotNo?: number;
  toNorlab?: boolean;
  norlabNo?: number;
  runDate?: Date;
  lotDate?: Date;
  norlabDate?: Date;
  archive: boolean;
  description: string;
  producedDate?: Date;
  producedAmount?: number;
  totalAmount?: number;
  runText: string;
  lotText: string;
  qaStation: string;
  numberOfPallets?: number;
  runSystemId: number;
  gradeId: number;
  packagingId?: number;
  palletId?: number;
  specificationId?: number;
  productStatusId: number;
  userId: number;
  lastUpdated: Date;
}

export interface ProductDto extends ProductBaseDto {
  id: number;
  runSystemNo: string;
  runSystemName: string;
  gradeName: string;
  productTypeName: string;
  segmentName: string;
  productStatusName: string;
  specificationNo: string;
  specificationName: string;
  lockWaybill?: boolean;

  mixtureNo?: number;
  mixtures?: string;
}

export interface ProductDetailDto extends ProductBaseDto {
  id: number;

  user: UserDto;
  packaging: PackagingDto;
  grade: GradeDto;
  productType: ProductTypeDto;
  segment: SegmentDto;
  pallet: PalletDto;
  specification: SpecificationDto;
  productStatus: ProductStatusDto;
  runSystem: RunSystemDto;

  mixtures: MixtureDto[];
  productMixtures: MixtureProductDto[];
  productParameters: ProductParameterDto[];
  productLogs: ProductLogDto[];
  inProducts: ProductProductDto[];
  hasProducts: ProductProductDto[];
  specificationParameters: SpecificationParameterDto[];
}

export interface ProductEditDto {
  id?: number;
  runNo?: number;
  lotNo?: number;
  toNorlab?: boolean;
  norlabNo?: number;
  runDate?: Date;
  lotDate?: Date;
  norlabDate?: Date;
  archive?: boolean;
  description?: string;
  producedDate?: Date;
  producedAmount?: number;
  totalAmount?: number;
  runText?: string;
  lotText?: string;
  qaStation?: string;
  numberOfPallets?: number;
  runSystemId?: number;
  gradeId?: number;
  packagingId?: number;
  palletId?: number;
  specificationId?: number;
  productStatusId?: number;
}

export interface ProductAnalysisDto extends ProductDto {
  parameters: ProductParameterDetailDto[];
}

export interface ProductStatusDto {
  id: number;
  name: string;
}

export interface ProductLogDto {
  id: number;
  productId: number;
  productStatusId: number;
  userId: number;
  regDate: Date;

  productStatusName: string;
  username: string;
}

export interface ProductStatusDto {
  id: number;
  name: string;
}

export enum ProductStatus {
  Approved = 1,
  ApprovedWithDeviation = 2,
  InProduction = 3
}

export interface ProductsByStatusDto {
  accepted: number;
  acceptedWithDeviation: number;
  inProduction: number;
}

export interface ProductsCreatedDto {
  date: Date;
  producedAmount: number;
}

export interface ProductNRunDto {
  count?: number;
  runSystemId?: number;
  gradeId?: number;
  specificationId?: number;
}
